@if (searchPermission) {
  <div role="search">
    <!-- Second from the top menu bar with global links  -->
    <div class="td-wb-search-button__container">
      <a tabindex="0"
              class="td-wb-search-button"
              id="searchButton"
              [name]="'tdWb.menu.SEARCH' | translate"
              tdWbHref="link_search_modal">
        <span class="td-wb-search-button__content">

          <td-wb-icon size="18"
                      iconId="search" />
           <span translate="tdWb.menu.SEARCH"></span>
        </span>
      </a>
    </div>
  </div>
}
